<div class="state">
  <mat-spinner diameter="32"></mat-spinner><span>Loading…</span>
</div>
